// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateUruguayanDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/\d{8}/.test(document)) {
    return { id: 'invalid-ci-pattern' };
  }
}
